<template>
  <v-autocomplete
      v-model="internalValue"
      :items="items"
      :loading="isLoading"
      :label="label || $t('sports')"
      :placeholder="placeholder || $t('startTypingToSearch')"
      :item-text="itemText"
      :item-value="itemValue"
      :multiple="multiple"
      :clearable="clearable"
      :disabled="disabled"
      :return-object="returnObject"
      :filter="customFilter"
      :hide-details="hideDetails"
      :dense="dense"
      chips
      small-chips
      @change="emitChange"
      :outlined="outlined"
  />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SportsSelectSearch',
  props: {
    value: { default: null },                 // ID o array di ID (o oggetti se returnObject=true)
    initValue: { type: [String, Array], default: null },
    multiple: { type: Boolean, default: true },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    includeAllOption: { type: Boolean, default: false }, // usabile solo in singola selezione
    itemText: { type: String, default: 'name' },
    itemValue: { type: String, default: '_id' },
    returnObject: { type: Boolean, default: false },      // se true, v-model = oggetto/i, altrimenti ID/ID[]
    outlined: { type: Boolean, default: true },
    hideDetails: { type: [Boolean, String], default: true },
    dense: { type: Boolean, default: true }
  },
  data () {
    return {
      isLoading: false,
      list: [],
      internalValue: this.multiple ? [] : null
    };
  },
  computed: {
    items () {
      var arr = Array.isArray(this.list) ? this.list.slice() : [];
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i].name && arr[i].desc) arr[i].name = arr[i].desc;
      }
      if (!this.multiple && this.includeAllOption) {
        var opt = {};
        opt[this.itemText]  = 'Tutti';
        opt[this.itemValue] = null;
        arr.unshift(opt);
      }
      return arr;
    }
  },
  watch: {
    value (v) {
      if (this.multiple) {
        this.internalValue = Array.isArray(v) ? v.slice() : [];
      } else {
        this.internalValue = typeof v === 'undefined' ? null : v;
      }
    }
  },
  created () {
    if (typeof this.value !== 'undefined' && this.value !== null) {
      this.internalValue = this.multiple ? (Array.isArray(this.value) ? this.value.slice() : []) : this.value;
    } else if (this.initValue) {
      this.internalValue = this.multiple ? (Array.isArray(this.initValue) ? this.initValue.slice() : [this.initValue]) : this.initValue;
    }
  },
  mounted () {
    this.bootstrap();
  },
  methods: {
    ...mapActions({ getSports: 'sports/index' }),

    async bootstrap () {
      this.isLoading = true;
      try {
        var data = await this.getSports();           // atteso: [{ _id, name/desc, ... }]
        // normalizza: ordina alfabeticamente per name/desc
        var list = Array.isArray(data) ? data.slice() : [];
        list.sort(function(a,b){
          var an = (a.name || a.desc || '').toString();
          var bn = (b.name || b.desc || '').toString();
          return an.localeCompare(bn);
        });
        this.list = list;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[SportsSelectSearch] load error:', e);
      } finally {
        this.isLoading = false;
      }
    },

    customFilter (item, queryText) {
      var q = (queryText || '').toString().toLowerCase();
      if (!q) return true;
      var t = (item[this.itemText] || '').toString().toLowerCase();
      var d = (item.desc || '').toString().toLowerCase();
      return t.indexOf(q) > -1 || d.indexOf(q) > -1;
    },

    emitChange () {
      // 1) v-model
      this.$emit('input', this.internalValue);

      // 2) 'message' come ID o array di ID
      var out;
      if (this.multiple) {
        if (this.returnObject) {
          out = Array.isArray(this.internalValue) ? this.internalValue.map(function(o){ return o ? o._id : null; }) : [];
        } else {
          out = Array.isArray(this.internalValue) ? this.internalValue.slice() : [];
        }
      } else {
        if (this.returnObject) {
          out = this.internalValue ? this.internalValue._id : '';
        } else {
          out = this.internalValue || '';
        }
      }
      this.$emit('message', out);
      this.$emit('change', out);
    }
  }
};
</script>
